import types from '../types';

/**
 * @param {types.Filter | types.Select} filter
 * @returns {types.Filter | types.Select}
 */
const getActiveFilterByType = filter => {
    switch (filter.type) {
        case 'checkbox': {
            const activeItems = filter.options.filter(option => {
                if (option.subOptions && option.subOptions.length) {
                    return (
                        option.checked ||
                        option.subOptions.some(item => item.checked)
                    );
                }

                return option.checked;
            });

            if (activeItems.length) {
                const filteredActiveItems = activeItems.map(item => {
                    if (item.subOptions && item.subOptions.length) {
                        return {
                            ...item,
                            subOptions: item.subOptions.filter(
                                subOption => subOption.checked
                            )
                        };
                    }

                    return item;
                });

                return {
                    ...filter,
                    options: filteredActiveItems
                };
            }

            return null;
        }

        default:
            return null;
    }
};

/**
 * @param {types.Filter[]} filters
 * @returns {types.Filter[]}
 */
const getActiveFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(getActiveFilterByType).filter(Boolean);
};

export default getActiveFilters;
